export interface CookieOptions {
	domain?: string;
	path?: string;
	sameSite?: 'Strict' | 'Lax' | 'None';
	secure?: boolean;
	maxAge?: number;
}

function buildCookieString(name: string, value: string, options: CookieOptions): string {
	const parts: string[] = [`${name}=${value}`];
	if (options.domain) parts.push(`domain=${options.domain}`);
	if (options.path) parts.push(`path=${options.path}`);
	if (options.sameSite) parts.push(`SameSite=${options.sameSite}`);
	if (options.secure) parts.push('Secure');
	if (options.maxAge !== undefined) parts.push(`max-age=${options.maxAge}`);
	return parts.join(';');
}

export function setCookie(name: string, value: string, options: CookieOptions): void {
	document.cookie = buildCookieString(name, value, options);
}

export function deleteCookie(name: string, options: Omit<CookieOptions, 'maxAge'>): void {
	document.cookie = buildCookieString(name, '', { ...options, maxAge: 0 });
}

export function readCookie(name: string): string | null {
	const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
	return match ? decodeURIComponent(match[1]) : null;
}

export function resolveCookieDomain(hostname: string, isProduction: boolean): string | undefined {
	if (isProduction) return '.we-online.com';
	if (hostname.endsWith('.wgn.wuerth.com')) return '.wgn.wuerth.com';
	if (hostname.endsWith('.wgs.wuerth.com')) return '.wgs.wuerth.com';
	return undefined;
}
